const block_icons = {
  heading: <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31.29"
    height="31.29"
    x="0"
    y="0"
    enableBackground="new 0 0 31.29 31.29"
    version="1.1"
    viewBox="0 0 31.29 31.29"
    xmlSpace="preserve"
  >
    <g xmlns="http://www.w3.org/2000/svg" fill="#b72121">
      <path d="M18.585 31.226v-1.833h.577c.497 0 .961-.036 1.395-.105.436-.072.812-.219 1.131-.438s.576-.537.769-.948c.192-.412.287-.959.287-1.643V16.03H8.547v10.229c0 .683.095 1.229.287 1.644.192.41.448.729.768.947.32.221.699.365 1.14.438.442.07.902.106 1.386.106h.577v1.833H0v-1.833h.555c.497 0 .961-.036 1.396-.106a2.828 2.828 0 001.141-.438c.326-.221.582-.537.769-.947.184-.412.275-.961.275-1.644v-21.4c0-.639-.096-1.153-.287-1.545a2.236 2.236 0 00-.78-.906 2.808 2.808 0 00-1.142-.416 9.23 9.23 0 00-1.373-.096H0V.063h12.705v1.833h-.577c-.483 0-.943.035-1.386.107-.44.07-.819.217-1.14.437-.319.22-.575.536-.768.949-.192.411-.287.959-.287 1.641v8.823h14.195V5.03c0-.683-.096-1.23-.287-1.642s-.448-.729-.768-.948a2.747 2.747 0 00-1.131-.437 8.527 8.527 0 00-1.396-.107h-.577V.063h12.705v1.833h-.553c-.498 0-.961.035-1.396.107-.434.07-.812.217-1.141.437-.326.22-.582.536-.768.948-.186.411-.277.959-.277 1.642v21.442c0 .64.097 1.155.287 1.545.192.392.453.687.779.884.326.2.705.331 1.141.396.434.064.892.096 1.373.096h.556v1.833H18.585z"></path>
    </g>

  </svg>
}

export default block_icons;